import { Component } from '@angular/core';

@Component({
  selector: 'app-seller-approve',
  templateUrl: './seller-approve.component.html',
  styleUrls: ['./seller-approve.component.css'],
})
export class SellerApproveComponent {
  title1 = 'Validation';
  title = 'Seller Information';
  title2 = 'Document Validation';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
